/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createOrganization = /* GraphQL */ `mutation CreateOrganization(
  $input: CreateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  createOrganization(input: $input, condition: $condition) {
    id
    name
    admins
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    fields {
      nextToken
      __typename
    }
    externalScheduleSources {
      nextToken
      __typename
    }
    gameSchedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    name
    admins
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    fields {
      nextToken
      __typename
    }
    externalScheduleSources {
      nextToken
      __typename
    }
    gameSchedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationMutationVariables,
  APITypes.UpdateOrganizationMutation
>;
export const deleteOrganization = /* GraphQL */ `mutation DeleteOrganization(
  $input: DeleteOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    name
    admins
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    fields {
      nextToken
      __typename
    }
    externalScheduleSources {
      nextToken
      __typename
    }
    gameSchedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationMutationVariables,
  APITypes.DeleteOrganizationMutation
>;
export const createProgram = /* GraphQL */ `mutation CreateProgram(
  $input: CreateProgramInput!
  $condition: ModelProgramConditionInput
) {
  createProgram(input: $input, condition: $condition) {
    id
    name
    type
    description
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProgramMutationVariables,
  APITypes.CreateProgramMutation
>;
export const updateProgram = /* GraphQL */ `mutation UpdateProgram(
  $input: UpdateProgramInput!
  $condition: ModelProgramConditionInput
) {
  updateProgram(input: $input, condition: $condition) {
    id
    name
    type
    description
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProgramMutationVariables,
  APITypes.UpdateProgramMutation
>;
export const deleteProgram = /* GraphQL */ `mutation DeleteProgram(
  $input: DeleteProgramInput!
  $condition: ModelProgramConditionInput
) {
  deleteProgram(input: $input, condition: $condition) {
    id
    name
    type
    description
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProgramMutationVariables,
  APITypes.DeleteProgramMutation
>;
export const createLeague = /* GraphQL */ `mutation CreateLeague(
  $input: CreateLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  createLeague(input: $input, condition: $condition) {
    id
    name
    admins
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeagueMutationVariables,
  APITypes.CreateLeagueMutation
>;
export const updateLeague = /* GraphQL */ `mutation UpdateLeague(
  $input: UpdateLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  updateLeague(input: $input, condition: $condition) {
    id
    name
    admins
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeagueMutationVariables,
  APITypes.UpdateLeagueMutation
>;
export const deleteLeague = /* GraphQL */ `mutation DeleteLeague(
  $input: DeleteLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  deleteLeague(input: $input, condition: $condition) {
    id
    name
    admins
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeagueMutationVariables,
  APITypes.DeleteLeagueMutation
>;
export const createRestRule = /* GraphQL */ `mutation CreateRestRule(
  $input: CreateRestRuleInput!
  $condition: ModelRestRuleConditionInput
) {
  createRestRule(input: $input, condition: $condition) {
    id
    name
    ageGroup
    global
    organizationId
    criteria
    weeklyOutsLimit
    pitchLimits {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    organizations {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRestRuleMutationVariables,
  APITypes.CreateRestRuleMutation
>;
export const updateRestRule = /* GraphQL */ `mutation UpdateRestRule(
  $input: UpdateRestRuleInput!
  $condition: ModelRestRuleConditionInput
) {
  updateRestRule(input: $input, condition: $condition) {
    id
    name
    ageGroup
    global
    organizationId
    criteria
    weeklyOutsLimit
    pitchLimits {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    organizations {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRestRuleMutationVariables,
  APITypes.UpdateRestRuleMutation
>;
export const deleteRestRule = /* GraphQL */ `mutation DeleteRestRule(
  $input: DeleteRestRuleInput!
  $condition: ModelRestRuleConditionInput
) {
  deleteRestRule(input: $input, condition: $condition) {
    id
    name
    ageGroup
    global
    organizationId
    criteria
    weeklyOutsLimit
    pitchLimits {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    organizations {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRestRuleMutationVariables,
  APITypes.DeleteRestRuleMutation
>;
export const createRestProfile = /* GraphQL */ `mutation CreateRestProfile(
  $input: CreateRestProfileInput!
  $condition: ModelRestProfileConditionInput
) {
  createRestProfile(input: $input, condition: $condition) {
    id
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    pitchCount
    daysRest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRestProfileMutationVariables,
  APITypes.CreateRestProfileMutation
>;
export const updateRestProfile = /* GraphQL */ `mutation UpdateRestProfile(
  $input: UpdateRestProfileInput!
  $condition: ModelRestProfileConditionInput
) {
  updateRestProfile(input: $input, condition: $condition) {
    id
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    pitchCount
    daysRest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRestProfileMutationVariables,
  APITypes.UpdateRestProfileMutation
>;
export const deleteRestProfile = /* GraphQL */ `mutation DeleteRestProfile(
  $input: DeleteRestProfileInput!
  $condition: ModelRestProfileConditionInput
) {
  deleteRestProfile(input: $input, condition: $condition) {
    id
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    pitchCount
    daysRest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRestProfileMutationVariables,
  APITypes.DeleteRestProfileMutation
>;
export const createTeam = /* GraphQL */ `mutation CreateTeam(
  $input: CreateTeamInput!
  $condition: ModelTeamConditionInput
) {
  createTeam(input: $input, condition: $condition) {
    id
    name
    ageGroup
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    coachUsernames
    players {
      nextToken
      __typename
    }
    coaches {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMutationVariables,
  APITypes.CreateTeamMutation
>;
export const updateTeam = /* GraphQL */ `mutation UpdateTeam(
  $input: UpdateTeamInput!
  $condition: ModelTeamConditionInput
) {
  updateTeam(input: $input, condition: $condition) {
    id
    name
    ageGroup
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    coachUsernames
    players {
      nextToken
      __typename
    }
    coaches {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMutationVariables,
  APITypes.UpdateTeamMutation
>;
export const deleteTeam = /* GraphQL */ `mutation DeleteTeam(
  $input: DeleteTeamInput!
  $condition: ModelTeamConditionInput
) {
  deleteTeam(input: $input, condition: $condition) {
    id
    name
    ageGroup
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    coachUsernames
    players {
      nextToken
      __typename
    }
    coaches {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeamMutationVariables,
  APITypes.DeleteTeamMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    email
    givenName
    familyName
    phone
    safetyCertified
    abcaId
    roles
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    givenName
    familyName
    phone
    safetyCertified
    abcaId
    roles
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    email
    givenName
    familyName
    phone
    safetyCertified
    abcaId
    roles
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createPlayer = /* GraphQL */ `mutation CreatePlayer(
  $input: CreatePlayerInput!
  $condition: ModelPlayerConditionInput
) {
  createPlayer(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    town
    state
    pitcher
    catcher
    battingHandedness
    throwingHandedness
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    pitchLogs {
      nextToken
      __typename
    }
    pitchViolations {
      nextToken
      __typename
    }
    parents {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlayerMutationVariables,
  APITypes.CreatePlayerMutation
>;
export const updatePlayer = /* GraphQL */ `mutation UpdatePlayer(
  $input: UpdatePlayerInput!
  $condition: ModelPlayerConditionInput
) {
  updatePlayer(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    town
    state
    pitcher
    catcher
    battingHandedness
    throwingHandedness
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    pitchLogs {
      nextToken
      __typename
    }
    pitchViolations {
      nextToken
      __typename
    }
    parents {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlayerMutationVariables,
  APITypes.UpdatePlayerMutation
>;
export const deletePlayer = /* GraphQL */ `mutation DeletePlayer(
  $input: DeletePlayerInput!
  $condition: ModelPlayerConditionInput
) {
  deletePlayer(input: $input, condition: $condition) {
    id
    name
    dateOfBirth
    town
    state
    pitcher
    catcher
    battingHandedness
    throwingHandedness
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    pitchLogs {
      nextToken
      __typename
    }
    pitchViolations {
      nextToken
      __typename
    }
    parents {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlayerMutationVariables,
  APITypes.DeletePlayerMutation
>;
export const createPitchLog = /* GraphQL */ `mutation CreatePitchLog(
  $input: CreatePitchLogInput!
  $condition: ModelPitchLogConditionInput
) {
  createPitchLog(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    playerRosterTeamId
    date
    pitches
    outsRecorded
    isSubstitute
    enteredByUsername
    lastModifiedByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePitchLogMutationVariables,
  APITypes.CreatePitchLogMutation
>;
export const updatePitchLog = /* GraphQL */ `mutation UpdatePitchLog(
  $input: UpdatePitchLogInput!
  $condition: ModelPitchLogConditionInput
) {
  updatePitchLog(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    playerRosterTeamId
    date
    pitches
    outsRecorded
    isSubstitute
    enteredByUsername
    lastModifiedByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePitchLogMutationVariables,
  APITypes.UpdatePitchLogMutation
>;
export const deletePitchLog = /* GraphQL */ `mutation DeletePitchLog(
  $input: DeletePitchLogInput!
  $condition: ModelPitchLogConditionInput
) {
  deletePitchLog(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    playerRosterTeamId
    date
    pitches
    outsRecorded
    isSubstitute
    enteredByUsername
    lastModifiedByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePitchLogMutationVariables,
  APITypes.DeletePitchLogMutation
>;
export const createPitchLogAuditEntry = /* GraphQL */ `mutation CreatePitchLogAuditEntry(
  $input: CreatePitchLogAuditEntryInput!
  $condition: ModelPitchLogAuditEntryConditionInput
) {
  createPitchLogAuditEntry(input: $input, condition: $condition) {
    id
    pitchLogId
    action
    changedByUsername
    changedAt
    summary
    beforeSnapshot
    afterSnapshot
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePitchLogAuditEntryMutationVariables,
  APITypes.CreatePitchLogAuditEntryMutation
>;
export const updatePitchLogAuditEntry = /* GraphQL */ `mutation UpdatePitchLogAuditEntry(
  $input: UpdatePitchLogAuditEntryInput!
  $condition: ModelPitchLogAuditEntryConditionInput
) {
  updatePitchLogAuditEntry(input: $input, condition: $condition) {
    id
    pitchLogId
    action
    changedByUsername
    changedAt
    summary
    beforeSnapshot
    afterSnapshot
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePitchLogAuditEntryMutationVariables,
  APITypes.UpdatePitchLogAuditEntryMutation
>;
export const deletePitchLogAuditEntry = /* GraphQL */ `mutation DeletePitchLogAuditEntry(
  $input: DeletePitchLogAuditEntryInput!
  $condition: ModelPitchLogAuditEntryConditionInput
) {
  deletePitchLogAuditEntry(input: $input, condition: $condition) {
    id
    pitchLogId
    action
    changedByUsername
    changedAt
    summary
    beforeSnapshot
    afterSnapshot
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePitchLogAuditEntryMutationVariables,
  APITypes.DeletePitchLogAuditEntryMutation
>;
export const createPitchViolation = /* GraphQL */ `mutation CreatePitchViolation(
  $input: CreatePitchViolationInput!
  $condition: ModelPitchViolationConditionInput
) {
  createPitchViolation(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    type
    date
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePitchViolationMutationVariables,
  APITypes.CreatePitchViolationMutation
>;
export const updatePitchViolation = /* GraphQL */ `mutation UpdatePitchViolation(
  $input: UpdatePitchViolationInput!
  $condition: ModelPitchViolationConditionInput
) {
  updatePitchViolation(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    type
    date
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePitchViolationMutationVariables,
  APITypes.UpdatePitchViolationMutation
>;
export const deletePitchViolation = /* GraphQL */ `mutation DeletePitchViolation(
  $input: DeletePitchViolationInput!
  $condition: ModelPitchViolationConditionInput
) {
  deletePitchViolation(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    type
    date
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePitchViolationMutationVariables,
  APITypes.DeletePitchViolationMutation
>;
export const createPlayerParent = /* GraphQL */ `mutation CreatePlayerParent(
  $input: CreatePlayerParentInput!
  $condition: ModelPlayerParentConditionInput
) {
  createPlayerParent(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    parentEmail
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlayerParentMutationVariables,
  APITypes.CreatePlayerParentMutation
>;
export const updatePlayerParent = /* GraphQL */ `mutation UpdatePlayerParent(
  $input: UpdatePlayerParentInput!
  $condition: ModelPlayerParentConditionInput
) {
  updatePlayerParent(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    parentEmail
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlayerParentMutationVariables,
  APITypes.UpdatePlayerParentMutation
>;
export const deletePlayerParent = /* GraphQL */ `mutation DeletePlayerParent(
  $input: DeletePlayerParentInput!
  $condition: ModelPlayerParentConditionInput
) {
  deletePlayerParent(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    parentEmail
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlayerParentMutationVariables,
  APITypes.DeletePlayerParentMutation
>;
export const createSubNotification = /* GraphQL */ `mutation CreateSubNotification(
  $input: CreateSubNotificationInput!
  $condition: ModelSubNotificationConditionInput
) {
  createSubNotification(input: $input, condition: $condition) {
    id
    fromTeamId
    toTeamId
    playerId
    date
    note
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubNotificationMutationVariables,
  APITypes.CreateSubNotificationMutation
>;
export const updateSubNotification = /* GraphQL */ `mutation UpdateSubNotification(
  $input: UpdateSubNotificationInput!
  $condition: ModelSubNotificationConditionInput
) {
  updateSubNotification(input: $input, condition: $condition) {
    id
    fromTeamId
    toTeamId
    playerId
    date
    note
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubNotificationMutationVariables,
  APITypes.UpdateSubNotificationMutation
>;
export const deleteSubNotification = /* GraphQL */ `mutation DeleteSubNotification(
  $input: DeleteSubNotificationInput!
  $condition: ModelSubNotificationConditionInput
) {
  deleteSubNotification(input: $input, condition: $condition) {
    id
    fromTeamId
    toTeamId
    playerId
    date
    note
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubNotificationMutationVariables,
  APITypes.DeleteSubNotificationMutation
>;
export const createSeason = /* GraphQL */ `mutation CreateSeason(
  $input: CreateSeasonInput!
  $condition: ModelSeasonConditionInput
) {
  createSeason(input: $input, condition: $condition) {
    id
    name
    year
    startDate
    endDate
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSeasonMutationVariables,
  APITypes.CreateSeasonMutation
>;
export const updateSeason = /* GraphQL */ `mutation UpdateSeason(
  $input: UpdateSeasonInput!
  $condition: ModelSeasonConditionInput
) {
  updateSeason(input: $input, condition: $condition) {
    id
    name
    year
    startDate
    endDate
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSeasonMutationVariables,
  APITypes.UpdateSeasonMutation
>;
export const deleteSeason = /* GraphQL */ `mutation DeleteSeason(
  $input: DeleteSeasonInput!
  $condition: ModelSeasonConditionInput
) {
  deleteSeason(input: $input, condition: $condition) {
    id
    name
    year
    startDate
    endDate
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSeasonMutationVariables,
  APITypes.DeleteSeasonMutation
>;
export const createDraftBoard = /* GraphQL */ `mutation CreateDraftBoard(
  $input: CreateDraftBoardInput!
  $condition: ModelDraftBoardConditionInput
) {
  createDraftBoard(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftees {
      nextToken
      __typename
    }
    assignments {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDraftBoardMutationVariables,
  APITypes.CreateDraftBoardMutation
>;
export const updateDraftBoard = /* GraphQL */ `mutation UpdateDraftBoard(
  $input: UpdateDraftBoardInput!
  $condition: ModelDraftBoardConditionInput
) {
  updateDraftBoard(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftees {
      nextToken
      __typename
    }
    assignments {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDraftBoardMutationVariables,
  APITypes.UpdateDraftBoardMutation
>;
export const deleteDraftBoard = /* GraphQL */ `mutation DeleteDraftBoard(
  $input: DeleteDraftBoardInput!
  $condition: ModelDraftBoardConditionInput
) {
  deleteDraftBoard(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftees {
      nextToken
      __typename
    }
    assignments {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDraftBoardMutationVariables,
  APITypes.DeleteDraftBoardMutation
>;
export const createEvaluationSession = /* GraphQL */ `mutation CreateEvaluationSession(
  $input: CreateEvaluationSessionInput!
  $condition: ModelEvaluationSessionConditionInput
) {
  createEvaluationSession(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftBoardId
    players {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEvaluationSessionMutationVariables,
  APITypes.CreateEvaluationSessionMutation
>;
export const updateEvaluationSession = /* GraphQL */ `mutation UpdateEvaluationSession(
  $input: UpdateEvaluationSessionInput!
  $condition: ModelEvaluationSessionConditionInput
) {
  updateEvaluationSession(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftBoardId
    players {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEvaluationSessionMutationVariables,
  APITypes.UpdateEvaluationSessionMutation
>;
export const deleteEvaluationSession = /* GraphQL */ `mutation DeleteEvaluationSession(
  $input: DeleteEvaluationSessionInput!
  $condition: ModelEvaluationSessionConditionInput
) {
  deleteEvaluationSession(input: $input, condition: $condition) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftBoardId
    players {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEvaluationSessionMutationVariables,
  APITypes.DeleteEvaluationSessionMutation
>;
export const createEvaluationPlayer = /* GraphQL */ `mutation CreateEvaluationPlayer(
  $input: CreateEvaluationPlayerInput!
  $condition: ModelEvaluationPlayerConditionInput
) {
  createEvaluationPlayer(input: $input, condition: $condition) {
    id
    evaluationSessionId
    evaluationSession {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    focus
    homeToFirstSeconds
    firstToSecondSeconds
    catcher
    pitcher
    drafteeId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEvaluationPlayerMutationVariables,
  APITypes.CreateEvaluationPlayerMutation
>;
export const updateEvaluationPlayer = /* GraphQL */ `mutation UpdateEvaluationPlayer(
  $input: UpdateEvaluationPlayerInput!
  $condition: ModelEvaluationPlayerConditionInput
) {
  updateEvaluationPlayer(input: $input, condition: $condition) {
    id
    evaluationSessionId
    evaluationSession {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    focus
    homeToFirstSeconds
    firstToSecondSeconds
    catcher
    pitcher
    drafteeId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEvaluationPlayerMutationVariables,
  APITypes.UpdateEvaluationPlayerMutation
>;
export const deleteEvaluationPlayer = /* GraphQL */ `mutation DeleteEvaluationPlayer(
  $input: DeleteEvaluationPlayerInput!
  $condition: ModelEvaluationPlayerConditionInput
) {
  deleteEvaluationPlayer(input: $input, condition: $condition) {
    id
    evaluationSessionId
    evaluationSession {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    focus
    homeToFirstSeconds
    firstToSecondSeconds
    catcher
    pitcher
    drafteeId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEvaluationPlayerMutationVariables,
  APITypes.DeleteEvaluationPlayerMutation
>;
export const createDraftee = /* GraphQL */ `mutation CreateDraftee(
  $input: CreateDrafteeInput!
  $condition: ModelDrafteeConditionInput
) {
  createDraftee(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    coachability
    availabilityRating
    catcher
    pitcher
    finalizedPlayerId
    assignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDrafteeMutationVariables,
  APITypes.CreateDrafteeMutation
>;
export const updateDraftee = /* GraphQL */ `mutation UpdateDraftee(
  $input: UpdateDrafteeInput!
  $condition: ModelDrafteeConditionInput
) {
  updateDraftee(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    coachability
    availabilityRating
    catcher
    pitcher
    finalizedPlayerId
    assignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDrafteeMutationVariables,
  APITypes.UpdateDrafteeMutation
>;
export const deleteDraftee = /* GraphQL */ `mutation DeleteDraftee(
  $input: DeleteDrafteeInput!
  $condition: ModelDrafteeConditionInput
) {
  deleteDraftee(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    coachability
    availabilityRating
    catcher
    pitcher
    finalizedPlayerId
    assignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDrafteeMutationVariables,
  APITypes.DeleteDrafteeMutation
>;
export const createDraftAssignment = /* GraphQL */ `mutation CreateDraftAssignment(
  $input: CreateDraftAssignmentInput!
  $condition: ModelDraftAssignmentConditionInput
) {
  createDraftAssignment(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    teamId
    drafteeId
    draftee {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    playerId
    rosterMembershipId
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDraftAssignmentMutationVariables,
  APITypes.CreateDraftAssignmentMutation
>;
export const updateDraftAssignment = /* GraphQL */ `mutation UpdateDraftAssignment(
  $input: UpdateDraftAssignmentInput!
  $condition: ModelDraftAssignmentConditionInput
) {
  updateDraftAssignment(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    teamId
    drafteeId
    draftee {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    playerId
    rosterMembershipId
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDraftAssignmentMutationVariables,
  APITypes.UpdateDraftAssignmentMutation
>;
export const deleteDraftAssignment = /* GraphQL */ `mutation DeleteDraftAssignment(
  $input: DeleteDraftAssignmentInput!
  $condition: ModelDraftAssignmentConditionInput
) {
  deleteDraftAssignment(input: $input, condition: $condition) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    teamId
    drafteeId
    draftee {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    playerId
    rosterMembershipId
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDraftAssignmentMutationVariables,
  APITypes.DeleteDraftAssignmentMutation
>;
export const createRosterMembership = /* GraphQL */ `mutation CreateRosterMembership(
  $input: CreateRosterMembershipInput!
  $condition: ModelRosterMembershipConditionInput
) {
  createRosterMembership(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    relationship
    isPrimary
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRosterMembershipMutationVariables,
  APITypes.CreateRosterMembershipMutation
>;
export const updateRosterMembership = /* GraphQL */ `mutation UpdateRosterMembership(
  $input: UpdateRosterMembershipInput!
  $condition: ModelRosterMembershipConditionInput
) {
  updateRosterMembership(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    relationship
    isPrimary
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRosterMembershipMutationVariables,
  APITypes.UpdateRosterMembershipMutation
>;
export const deleteRosterMembership = /* GraphQL */ `mutation DeleteRosterMembership(
  $input: DeleteRosterMembershipInput!
  $condition: ModelRosterMembershipConditionInput
) {
  deleteRosterMembership(input: $input, condition: $condition) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    relationship
    isPrimary
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRosterMembershipMutationVariables,
  APITypes.DeleteRosterMembershipMutation
>;
export const createUserAssignment = /* GraphQL */ `mutation CreateUserAssignment(
  $input: CreateUserAssignmentInput!
  $condition: ModelUserAssignmentConditionInput
) {
  createUserAssignment(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    relationship
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserAssignmentMutationVariables,
  APITypes.CreateUserAssignmentMutation
>;
export const updateUserAssignment = /* GraphQL */ `mutation UpdateUserAssignment(
  $input: UpdateUserAssignmentInput!
  $condition: ModelUserAssignmentConditionInput
) {
  updateUserAssignment(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    relationship
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserAssignmentMutationVariables,
  APITypes.UpdateUserAssignmentMutation
>;
export const deleteUserAssignment = /* GraphQL */ `mutation DeleteUserAssignment(
  $input: DeleteUserAssignmentInput!
  $condition: ModelUserAssignmentConditionInput
) {
  deleteUserAssignment(input: $input, condition: $condition) {
    id
    userId
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    relationship
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserAssignmentMutationVariables,
  APITypes.DeleteUserAssignmentMutation
>;
export const createCoachLineupPlan = /* GraphQL */ `mutation CreateCoachLineupPlan(
  $input: CreateCoachLineupPlanInput!
  $condition: ModelCoachLineupPlanConditionInput
) {
  createCoachLineupPlan(input: $input, condition: $condition) {
    id
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    title
    gameDate
    opponentName
    inningsPlanned
    battingOrder
    defensiveAssignments
    notes
    createdByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCoachLineupPlanMutationVariables,
  APITypes.CreateCoachLineupPlanMutation
>;
export const updateCoachLineupPlan = /* GraphQL */ `mutation UpdateCoachLineupPlan(
  $input: UpdateCoachLineupPlanInput!
  $condition: ModelCoachLineupPlanConditionInput
) {
  updateCoachLineupPlan(input: $input, condition: $condition) {
    id
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    title
    gameDate
    opponentName
    inningsPlanned
    battingOrder
    defensiveAssignments
    notes
    createdByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCoachLineupPlanMutationVariables,
  APITypes.UpdateCoachLineupPlanMutation
>;
export const deleteCoachLineupPlan = /* GraphQL */ `mutation DeleteCoachLineupPlan(
  $input: DeleteCoachLineupPlanInput!
  $condition: ModelCoachLineupPlanConditionInput
) {
  deleteCoachLineupPlan(input: $input, condition: $condition) {
    id
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    title
    gameDate
    opponentName
    inningsPlanned
    battingOrder
    defensiveAssignments
    notes
    createdByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCoachLineupPlanMutationVariables,
  APITypes.DeleteCoachLineupPlanMutation
>;
export const createTeamPlayer = /* GraphQL */ `mutation CreateTeamPlayer(
  $input: CreateTeamPlayerInput!
  $condition: ModelTeamPlayerConditionInput
) {
  createTeamPlayer(input: $input, condition: $condition) {
    id
    teamID
    playerID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamPlayerMutationVariables,
  APITypes.CreateTeamPlayerMutation
>;
export const updateTeamPlayer = /* GraphQL */ `mutation UpdateTeamPlayer(
  $input: UpdateTeamPlayerInput!
  $condition: ModelTeamPlayerConditionInput
) {
  updateTeamPlayer(input: $input, condition: $condition) {
    id
    teamID
    playerID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamPlayerMutationVariables,
  APITypes.UpdateTeamPlayerMutation
>;
export const deleteTeamPlayer = /* GraphQL */ `mutation DeleteTeamPlayer(
  $input: DeleteTeamPlayerInput!
  $condition: ModelTeamPlayerConditionInput
) {
  deleteTeamPlayer(input: $input, condition: $condition) {
    id
    teamID
    playerID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeamPlayerMutationVariables,
  APITypes.DeleteTeamPlayerMutation
>;
export const createField = /* GraphQL */ `mutation CreateField(
  $input: CreateFieldInput!
  $condition: ModelFieldConditionInput
) {
  createField(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    address
    town
    state
    surfaceType
    notes
    availability {
      nextToken
      __typename
    }
    schedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFieldMutationVariables,
  APITypes.CreateFieldMutation
>;
export const updateField = /* GraphQL */ `mutation UpdateField(
  $input: UpdateFieldInput!
  $condition: ModelFieldConditionInput
) {
  updateField(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    address
    town
    state
    surfaceType
    notes
    availability {
      nextToken
      __typename
    }
    schedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFieldMutationVariables,
  APITypes.UpdateFieldMutation
>;
export const deleteField = /* GraphQL */ `mutation DeleteField(
  $input: DeleteFieldInput!
  $condition: ModelFieldConditionInput
) {
  deleteField(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    address
    town
    state
    surfaceType
    notes
    availability {
      nextToken
      __typename
    }
    schedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFieldMutationVariables,
  APITypes.DeleteFieldMutation
>;
export const createFieldAvailability = /* GraphQL */ `mutation CreateFieldAvailability(
  $input: CreateFieldAvailabilityInput!
  $condition: ModelFieldAvailabilityConditionInput
) {
  createFieldAvailability(input: $input, condition: $condition) {
    id
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    organizationId
    date
    startTime
    endTime
    status
    source
    sourceRef
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFieldAvailabilityMutationVariables,
  APITypes.CreateFieldAvailabilityMutation
>;
export const updateFieldAvailability = /* GraphQL */ `mutation UpdateFieldAvailability(
  $input: UpdateFieldAvailabilityInput!
  $condition: ModelFieldAvailabilityConditionInput
) {
  updateFieldAvailability(input: $input, condition: $condition) {
    id
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    organizationId
    date
    startTime
    endTime
    status
    source
    sourceRef
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFieldAvailabilityMutationVariables,
  APITypes.UpdateFieldAvailabilityMutation
>;
export const deleteFieldAvailability = /* GraphQL */ `mutation DeleteFieldAvailability(
  $input: DeleteFieldAvailabilityInput!
  $condition: ModelFieldAvailabilityConditionInput
) {
  deleteFieldAvailability(input: $input, condition: $condition) {
    id
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    organizationId
    date
    startTime
    endTime
    status
    source
    sourceRef
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFieldAvailabilityMutationVariables,
  APITypes.DeleteFieldAvailabilityMutation
>;
export const createExternalScheduleSource = /* GraphQL */ `mutation CreateExternalScheduleSource(
  $input: CreateExternalScheduleSourceInput!
  $condition: ModelExternalScheduleSourceConditionInput
) {
  createExternalScheduleSource(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    sourceType
    url
    status
    lastImportedAt
    lastError
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExternalScheduleSourceMutationVariables,
  APITypes.CreateExternalScheduleSourceMutation
>;
export const updateExternalScheduleSource = /* GraphQL */ `mutation UpdateExternalScheduleSource(
  $input: UpdateExternalScheduleSourceInput!
  $condition: ModelExternalScheduleSourceConditionInput
) {
  updateExternalScheduleSource(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    sourceType
    url
    status
    lastImportedAt
    lastError
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExternalScheduleSourceMutationVariables,
  APITypes.UpdateExternalScheduleSourceMutation
>;
export const deleteExternalScheduleSource = /* GraphQL */ `mutation DeleteExternalScheduleSource(
  $input: DeleteExternalScheduleSourceInput!
  $condition: ModelExternalScheduleSourceConditionInput
) {
  deleteExternalScheduleSource(input: $input, condition: $condition) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    sourceType
    url
    status
    lastImportedAt
    lastError
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExternalScheduleSourceMutationVariables,
  APITypes.DeleteExternalScheduleSourceMutation
>;
export const createPractice = /* GraphQL */ `mutation CreatePractice(
  $input: CreatePracticeInput!
  $condition: ModelPracticeConditionInput
) {
  createPractice(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    date
    startTime
    endTime
    status
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePracticeMutationVariables,
  APITypes.CreatePracticeMutation
>;
export const updatePractice = /* GraphQL */ `mutation UpdatePractice(
  $input: UpdatePracticeInput!
  $condition: ModelPracticeConditionInput
) {
  updatePractice(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    date
    startTime
    endTime
    status
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePracticeMutationVariables,
  APITypes.UpdatePracticeMutation
>;
export const deletePractice = /* GraphQL */ `mutation DeletePractice(
  $input: DeletePracticeInput!
  $condition: ModelPracticeConditionInput
) {
  deletePractice(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    date
    startTime
    endTime
    status
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePracticeMutationVariables,
  APITypes.DeletePracticeMutation
>;
export const createGameSchedule = /* GraphQL */ `mutation CreateGameSchedule(
  $input: CreateGameScheduleInput!
  $condition: ModelGameScheduleConditionInput
) {
  createGameSchedule(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    leagueId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    title
    scheduleType
    date
    startTime
    endTime
    opponentName
    externalSourceId
    externalEventId
    conflictStatus
    conflictDetails
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGameScheduleMutationVariables,
  APITypes.CreateGameScheduleMutation
>;
export const updateGameSchedule = /* GraphQL */ `mutation UpdateGameSchedule(
  $input: UpdateGameScheduleInput!
  $condition: ModelGameScheduleConditionInput
) {
  updateGameSchedule(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    leagueId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    title
    scheduleType
    date
    startTime
    endTime
    opponentName
    externalSourceId
    externalEventId
    conflictStatus
    conflictDetails
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGameScheduleMutationVariables,
  APITypes.UpdateGameScheduleMutation
>;
export const deleteGameSchedule = /* GraphQL */ `mutation DeleteGameSchedule(
  $input: DeleteGameScheduleInput!
  $condition: ModelGameScheduleConditionInput
) {
  deleteGameSchedule(input: $input, condition: $condition) {
    id
    organizationId
    teamId
    leagueId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    title
    scheduleType
    date
    startTime
    endTime
    opponentName
    externalSourceId
    externalEventId
    conflictStatus
    conflictDetails
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGameScheduleMutationVariables,
  APITypes.DeleteGameScheduleMutation
>;
export const createUserTeams = /* GraphQL */ `mutation CreateUserTeams(
  $input: CreateUserTeamsInput!
  $condition: ModelUserTeamsConditionInput
) {
  createUserTeams(input: $input, condition: $condition) {
    id
    teamId
    userId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserTeamsMutationVariables,
  APITypes.CreateUserTeamsMutation
>;
export const updateUserTeams = /* GraphQL */ `mutation UpdateUserTeams(
  $input: UpdateUserTeamsInput!
  $condition: ModelUserTeamsConditionInput
) {
  updateUserTeams(input: $input, condition: $condition) {
    id
    teamId
    userId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserTeamsMutationVariables,
  APITypes.UpdateUserTeamsMutation
>;
export const deleteUserTeams = /* GraphQL */ `mutation DeleteUserTeams(
  $input: DeleteUserTeamsInput!
  $condition: ModelUserTeamsConditionInput
) {
  deleteUserTeams(input: $input, condition: $condition) {
    id
    teamId
    userId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserTeamsMutationVariables,
  APITypes.DeleteUserTeamsMutation
>;
